import $ from 'jquery'
import select2 from 'select2'
import 'select2/dist/css/select2.css'

class Account {
  init () {
    select2($)
    $('.custom-select2').select2()
  }
}

export default Account
